//
import { SlizeZone } from "components/prismic";
import React from "react";
import styled from "styled-components";
//
export default ({ className, content }) => (
	<Job className={className}>
		<SlizeZone slices={content} />
	</Job>
);
//
const Job = styled.div`
  padding: 0 0 2rem;
  width: 100%;

  @media (min-width: 768px) {
    padding: 2rem 0;
  }
`;
